var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMoonStars = function SvgIconMoonStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.75 2.25a1 1 0 1 0-2 0v.5h-.5a1 1 0 1 0 0 2h.5v.5a1 1 0 1 0 2 0v-.5h.5a1 1 0 1 0 0-2h-.5zM20.25 5a1 1 0 0 1 1 1v1.25h1.25a1 1 0 1 1 0 2h-1.25v1.25a1 1 0 1 1-2 0V9.25H18a1 1 0 1 1 0-2h1.25V6a1 1 0 0 1 1-1m-9.593-1.046a1 1 0 0 0-1.231-1.233 9.625 9.625 0 1 0 11.853 11.853 1 1 0 0 0-1.233-1.23 7.615 7.615 0 0 1-9.389-9.39m-4.08 2.687a7.6 7.6 0 0 1 1.825-1.367 9.616 9.616 0 0 0 10.324 10.324 7.625 7.625 0 1 1-12.15-8.957",
    clipRule: "evenodd"
  })));
};
export default SvgIconMoonStars;